import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Phone, Calendar, LayoutGrid, MessageSquare, Workflow, Plug, BarChart3, Sparkles, Bot, Activity } from 'lucide-react';
const features = [{
  icon: Phone,
  title: 'AI Voice Agents',
  desc: 'Handles reservations and inquiries 24/7.'
}, {
  icon: Calendar,
  title: 'Booking Intelligence',
  desc: 'Optimizes table turns and maximizes yield.'
}, {
  icon: LayoutGrid,
  title: 'Live Floor Management',
  desc: 'Real-time visibility into every table.'
}, {
  icon: MessageSquare,
  title: 'Guest Engagement',
  desc: 'Automated, personalized communication.'
}, {
  icon: Workflow,
  title: 'Smart Workflows',
  desc: 'Connects FOH and BOH seamlessly.'
}, {
  icon: Plug,
  title: 'Integrated Systems',
  desc: 'Syncs with your existing POS and PMS.'
}, {
  icon: BarChart3,
  title: 'Venue Intelligence',
  desc: 'Predictive analytics for staffing and stock.'
}, {
  icon: Bot,
  title: 'AI Staff Copilots',
  desc: 'Assists your team with instant knowledge.'
}, {
  icon: Activity,
  title: 'Operational Automation',
  desc: 'Reduces manual admin to zero.'
}, {
  icon: Sparkles,
  title: 'Central Visibility',
  desc: 'One dashboard for your entire group.'
}];
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
export function PlatformOverview() {
  return <section className="py-32 bg-brand-black relative z-10" data-id="element-592">
      <div className="max-w-7xl mx-auto px-6" data-id="element-593">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeUp} className="text-center mb-20" data-id="element-594">
          <h2 className="text-4xl md:text-6xl font-display mb-6 leading-[1.0] tracking-tight text-balance text-white" data-id="element-595">
            One platform. <br className="hidden md:block" data-id="element-596" />
            <span className="text-gray-500" data-id="element-597">Every hospitality operation.</span>
          </h2>
          <p className="text-xl text-gray-400 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-598">
            Aijentik Hospitality unifies the moving parts of running a venue
            into a single intelligent system.
          </p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-599">
          {features.map((feature, i) => <motion.div key={i} variants={fadeUp} className="bg-[#0A0A0A] border border-white/5 p-8 rounded-3xl flex flex-col items-start group transition-all duration-500 ease-premium hover:-translate-y-1 hover:border-brand-orange/20 hover:shadow-[0_8px_40px_rgba(219,127,74,0.08)]" data-id="element-600">
              <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center mb-6 group-hover:bg-brand-orange/10 transition-colors duration-500" data-id="element-601">
                <feature.icon className="w-6 h-6 text-gray-400 group-hover:text-brand-orange transition-colors duration-500" data-id="element-602" />
              </div>
              <h3 className="text-lg font-medium text-white tracking-tight mb-2" data-id="element-603">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-400 font-light leading-relaxed" data-id="element-604">
                {feature.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}